<template lang="pug">
  v-app
    InternalCodeSearchModal(@product="showProduct")
    v-dialog(v-model="showDialog")
      ProductPriceDetail(
        :product="activeProduct"
        v-if="activeProduct"
        )
</template>

<script>
import InternalCodeSearchModal from '../../components/ProductSearchPlain/InternalCodeSearchModal'
import ProductPriceDetail from './ProductPriceDetail.vue'
import { findByKey } from '../../services/API/ProductService'
const initialState = () => ({ activeProduct: null, showDialog: false })
export default {
    components: { InternalCodeSearchModal, ProductPriceDetail },
    data: () => initialState(),
    methods: {
        showProduct(product) {
            this.activeProduct = product
            this.showDialog = true
        },
        async handleScanner(code) {
            const product = await findByKey({
                field: 'upc_code',
                value: code,
            })
            this.activeProduct = product
            this.showDialog = true
        },
    },
    watch: {
        showDialog(v) {
            if (!v) this.activeProduct = null
        },
    },
    mounted() {
        this.$barcodeScanner.init(this.handleScanner)
    },
    beforeDestroy() {
        this.$barcodeScanner.destroy()
    },
}
</script>
